import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { LayoutProvider } from 'bento-ordering/context/LayoutContext';

function Layout({ children, AppBarComponent, ...rest }) {
  return (
    <LayoutProvider>
      <Box paddingTop={8} paddingBottom={3} {...rest}>
        <AppBarComponent />
        <main>{children}</main>
      </Box>
    </LayoutProvider>
  );
}

Layout.propTypes = {
  AppBarComponent: PropTypes.elementType.isRequired,
  children: CHILDREN_PROP_TYPES.isRequired
};

export default Layout;
